import { createContext, useContext } from "react";
import { useSelector } from "react-redux";

const TranslationContext = createContext();

export default function TranslationProvider({ children }) {

	const { translations } = useSelector(state => state.Translations);

	const translate = key => {
		const translation = translations.find(item => item.shortKey?.trim() === key);
		return translation ? translation.value : key;
	};


	return (
		<TranslationContext.Provider value={{ translate }}>
			<div>{children}</div>
		</TranslationContext.Provider>
	);
}

export const useTranslation = () => {
	return useContext(TranslationContext);
};
